import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { EASE } from "./Reveal";

const Line = ({ children, delay }) => (
    <span className="mask-line">
        <motion.span className="block" initial={{ y: "112%" }} animate={{ y: "0%" }} transition={{ duration: 1.1, ease: EASE, delay }}>
            {children}
        </motion.span>
    </span>
);

const Kicker = () => (
    <div className="flex items-baseline justify-end">
        <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="font-mono2 text-[10px] md:text-xs tracking-[0.3em] text-[var(--mute)]"
            data-testid="hero-kicker"
        >
            PORTFOLIO — 2026 &nbsp;/&nbsp; BERGAMO, IT
        </motion.p>
    </div>
);

const Copy = () => (
    <div>
        <h1 className="font-display uppercase leading-[0.95] tracking-tight text-4xl sm:text-5xl lg:text-6xl" data-testid="hero-title">
            <Line delay={0.25}>Marco</Line>
            <Line delay={0.37}>Giavazzi</Line>
        </h1>
        <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.6 }}
            className="font-mono2 text-[11px] md:text-sm tracking-[0.2em] uppercase mt-6"
            data-testid="hero-subtitle"
        >
            Graphic design / Fashion design / Art direction
        </motion.p>
        <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.9, delay: 1 }}
            className="font-mono2 text-[10px] md:text-xs tracking-[0.2em] text-[var(--mute)] uppercase mt-10 md:mt-14"
        >
            ↓ Scroll
        </motion.p>
    </div>
);

export const Hero = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
    const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "10%"]);

    return (
        <section ref={ref} data-testid="hero" className="relative min-h-[92vh] overflow-hidden flex flex-col">
            <motion.img
                src="/assets/hero-pile.jpg"
                alt="Still life of the full garment pile on an antique wooden trunk in a dark studio"
                initial={{ opacity: 0, scale: 1.05 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.4, ease: EASE }}
                className="absolute inset-0 w-full h-full object-cover"
                style={{ y: imgY }}
                data-testid="hero-image"
            />
            <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-[rgba(10,10,10,0.88)] via-[rgba(10,10,10,0.15)] to-[rgba(10,10,10,0.4)]" />
            <div className="relative flex-1 flex flex-col justify-between px-6 md:px-12 pt-28 md:pt-36 pb-10 md:pb-14">
                <Kicker />
                <Copy />
            </div>
        </section>
    );
};
